import { getGlobalSettingsAccountMailboxInfo } from 'owa-account-source-list-store';
import { lazyOpenYammerPublisher } from 'owa-yammer-publisher';
import { logUsage } from 'owa-analytics';

export default function onNewYammerPost(): void {
    logUsage('YammerPublisher_NewPost', getGlobalSettingsAccountMailboxInfo());
    lazyOpenYammerPublisher.importAndExecute();
}
